import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-document-active",
  "use": "icon-document-active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-document-active\">\n<path d=\"M16.25 2.5C16.9404 2.5 17.5 3.05965 17.5 3.75V16.25C17.5 16.9404 16.9404 17.5 16.25 17.5H3.75C3.05965 17.5 2.5 16.9404 2.5 16.25V3.75C2.5 3.05964 3.05964 2.5 3.75 2.5H16.25ZM5.625 9.375V10.625H11.25V9.375H5.625ZM5.625 6.25V7.5H14.375V6.25H5.625Z\" fill=\"#03C3D7\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol